<template>
  <div class="components">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Elements_Route",
};
</script>

<style scoped>
.components {
  margin-top: 20px;
}
</style>
